import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import LoadingComponent from './../../widgets/LoadingComponent';
import { getData, postData } from './../../api/ApiRest'
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import auditoriaSet from '../../widgets/Auditoria';




function EmpresaNuevoModal(props) {
    const [typesDocumentIdentifications, setTypesDocumentIdentifications] = useState([]);
    const [typeOrganizations, setTypeOrganizations] = useState([]);
    const [typeRegimens, setTypeRegimens] = useState([]);
    const [typeLiabilites, setTypeLiabilites] = useState([]);
    const [departamentsCities, setDepartamentsCities] = useState([]);
    const [departmentid, setDepartmentid] = useState('');
    const [Cities, setCities] = useState([]);
    const [loading, setLoading] = useState(false);

    const [idenfication, setIdentification] = useState({ Nit: '', Dv: '' });

    const [nombreAlterno, setNombreAlterno] = useState('');
    const [datosNuevoEmpresa, setDatosNuevoEmpresa] = useState({
        type_document_identification_id: 3,
        type_organization_id: 2,
        type_regime_id: 2,
        type_liability_id: 14,
        business_name: '',
        merchant_registration: '0000000-00',
        municipality_id: 820,
        address: '',
        phone: 0,
        email: '',
        mail_host: 'live.smtp.mailtrap.io',
        mail_port: '587',
        mail_username: 'api',
        mail_password: '30c069e7598c4655c3a1e729d31371ff',
        mail_encryption: 'tls'
    })



    const initForm = () => {
        setLoading(true);


        getData('api/Configuracion/Company/CreateGetInfo',
            { id: props.CompanySelect.id === undefined ? '' : props.CompanySelect.id }, true).then(response => {

                console.log(response);

                if (response.status === true) {
                    setTypesDocumentIdentifications(response.typesDocumentIdentifications);
                    setTypeOrganizations(response.typesOrganizations);
                    setTypeRegimens(response.typesRegimens);
                    setTypeLiabilites(response.typesLiabilites);
                    setDepartamentsCities(response.departamentsCities);
                    setCities(response.cities);
                    setDatosNuevoEmpresa(response.model);
                    setIdentification({ Nit: response.identification.nit, Dv: response.identification.dv });
                    setDepartmentid(response.municipalityId);

                } else {
                    console.log(response);
                }

                setLoading(false);

            }, error => {
                console.log(error);
                setLoading(false);
                alert('Algo salio mal al cargar el formulario');
            })

    }

    const citiesLoad = (Departmanentid) => {
        setLoading(true);

        getData('api/Configuracion/Company/CitiesGet', { Departamentid: Departmanentid },
            false).then(response => {

                setCities(response.cities);

                setLoading(false);

            }, error => {
                console.log(error);
                setLoading(false);
                alert('Algo salio mal al cargar el formulario');
            })

    }


    const changeNit = (nit) => {
        let vpri, x, y, z, i, dv1;


        if (isNaN(nit)) {
            alert('El valor digitado no es un numero valido');
            return 0;
        } else {
            vpri = new Array(16);
            x = 0;
            y = 0;
            z = nit.length;
            vpri[1] = 3;
            vpri[2] = 7;
            vpri[3] = 13;
            vpri[4] = 17;
            vpri[5] = 19;
            vpri[6] = 23;
            vpri[7] = 29;
            vpri[8] = 37;
            vpri[9] = 41;
            vpri[10] = 43;
            vpri[11] = 47;
            vpri[12] = 53;
            vpri[13] = 59;
            vpri[14] = 67;
            vpri[15] = 71;
            for (i = 0; i < z; i++) {
                y = (nit.substr(i, 1));

                x += (y * vpri[z - i]);

            }
            y = x % 11
            //document.write(y+"<br>");
            if (y > 1) {
                dv1 = 11 - y;
            } else {
                dv1 = y;
            }

            return dv1;
        }
    }



    const guardar = (event) => {
        setLoading(true);
        event.preventDefault();

        postData('api/Configuracion/Company/CreateOrUpdateCompany', {
            Nit: idenfication.Nit,
            Dv: idenfication.Dv,
            Nuevo: true,
            NombreAlterno: nombreAlterno,
        }, datosNuevoEmpresa, false).then(response => {
            if (response.status === true) {
                alert(response.textoJson);

                ///Función para guardar la auditoria cuando se guarda un cambio de la empresa
                auditoriaSet(datosNuevoEmpresa, {}, 'C', 'Empresa', null, 'NuevaEmpresa');

                setLoading(false);
                props.cerrarModal();
            } else {
                alert(response.msj);
            }
            console.log(response);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('Algo salio mal, por favor verifica la informacion');
        })




    }


    const cargarInfoMailHost = () => {
        setDatosNuevoEmpresa({
            ...datosNuevoEmpresa,
            mail_host: 'live.smtp.mailtrap.io',
            mail_port: '587',
            mail_username: 'api',
            mail_password: '30c069e7598c4655c3a1e729d31371ff',
            mail_encryption: 'tls'
        })
    }


    return (
        <Modal
            size='xl'
            show={props.Show}
            onShow={initForm}
            onHide={props.cerrarModal}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {props.CompanySelect == null ? 'Nueva Empresa' : 'Editar Empresa'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {<LoadingComponent Loading={loading} />}



                <Form onSubmit={guardar}>
                    <div className='row'>

                        <div className='col-md-4'>
                            <FloatingLabel
                                controlId='floatingTipoIdentificacion'
                                label="Tipo Identificacion"
                                className="mb-3"
                            >
                                <Form.Select
                                    size='sm'
                                    value={datosNuevoEmpresa.type_document_identification_id}
                                    onChange={event => {
                                        setDatosNuevoEmpresa({
                                            ...datosNuevoEmpresa,
                                            type_document_identification_id: event.target.value
                                        })
                                    }}
                                >
                                    <option value="">Seleccione</option>
                                    {typesDocumentIdentifications.map((item, key) =>
                                        <option key={key} value={item.value}>{item.text}</option>)}
                                </Form.Select>
                            </FloatingLabel>
                        </div>

                        <div className='col-md-6'>
                            <FloatingLabel
                                controlId="Nit"
                                label="Nit"
                                className="mb-3"
                            >
                                <Form.Control
                                    size='sm'
                                    type="number"
                                    required={true}
                                    autoComplete='off'
                                    placeholder="Nit"
                                    value={idenfication.Nit}
                                    onChange={value => {
                                        setIdentification({
                                            ...idenfication,
                                            Nit: value.target.value,
                                            Dv: changeNit(value.target.value)
                                        })

                                    }}
                                />
                            </FloatingLabel>
                        </div>

                        <div className='col-md-2'>
                            <FloatingLabel
                                controlId="Dv"
                                label="Dv"
                                className="mb-3"
                            >
                                <Form.Control
                                    size='sm'
                                    type="number"
                                    min={0}
                                    max={9}
                                    required={true}
                                    readOnly={true}
                                    autoComplete='off'
                                    placeholder="Dv"
                                    value={idenfication.Dv}
                                // onChange={value => setIdentification({ ...idenfication, Dv: value.target.value })}
                                />
                            </FloatingLabel>
                        </div>


                        <div className='col-md-4'>
                            <FloatingLabel
                                controlId='floatingTipoOrganizacion'
                                label="Tipo Organizacion"
                                className="mb-3"
                            >
                                <Form.Select
                                    size='sm'
                                    value={datosNuevoEmpresa.type_organization_id}
                                    onChange={event => {
                                        setDatosNuevoEmpresa({
                                            ...datosNuevoEmpresa,
                                            type_organization_id: event.target.value
                                        })
                                    }}
                                >
                                    <option value="">Seleccione</option>
                                    {typeOrganizations.map((item, key) =>
                                        <option key={key} value={item.value}>{item.text}</option>)}
                                </Form.Select>
                            </FloatingLabel>
                        </div>

                        <div className='col-md-4'>
                            <FloatingLabel
                                controlId='floatingTipoResponsabilidad'
                                label="Tipo Responsabilidad"
                                className="mb-3"
                            >
                                <Form.Select
                                    size='sm'
                                    value={datosNuevoEmpresa.type_regime_id}
                                    onChange={event => {
                                        setDatosNuevoEmpresa({
                                            ...datosNuevoEmpresa,
                                            type_regime_id: event.target.value
                                        })
                                    }}
                                >
                                    <option value="">Seleccione</option>
                                    {typeRegimens.map((item, key) =>
                                        <option key={key} value={item.value}>{item.text}</option>)}
                                </Form.Select>
                            </FloatingLabel>
                        </div>

                        <div className='col-md-4'>
                            <FloatingLabel
                                controlId='floatingTipoRegimen'
                                label="Tipo Regimen"
                                className="mb-3"
                            >
                                <Form.Select
                                    size='sm'
                                    value={datosNuevoEmpresa.type_liability_id}
                                    onChange={event => {
                                        setDatosNuevoEmpresa({
                                            ...datosNuevoEmpresa,
                                            type_liability_id: event.target.value
                                        })
                                    }}
                                >
                                    <option value="">Seleccione</option>
                                    {typeLiabilites.map((item, key) =>
                                        <option key={key} value={item.value}>{item.text}</option>)}
                                </Form.Select>
                            </FloatingLabel>
                        </div>

                        <div className='col-md-12'>
                            <FloatingLabel
                                controlId="businessName"
                                label="Nombre de empresa"
                                className="mb-3"
                            >
                                <Form.Control
                                    type="text"
                                    size='sm'
                                    required={true}
                                    autoComplete='off'
                                    placeholder="Nombre de empresa"
                                    value={datosNuevoEmpresa.business_name}
                                    onChange={value => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, business_name: value.target.value })}
                                />
                            </FloatingLabel>
                        </div>

                        <div className='col-md-12'>
                            <FloatingLabel
                                controlId="businessName"
                                label="Nombre Alterno"
                                className="mb-3"
                            >
                                <Form.Control
                                    type="text"
                                    size='sm'
                                    required={true}
                                    autoComplete='off'
                                    placeholder="Nombre Alterno"
                                    value={nombreAlterno}
                                    onChange={value => setNombreAlterno(value.target.value)}
                                />
                            </FloatingLabel>
                        </div>

                        <div className='col-md-4'>
                            <FloatingLabel
                                controlId="telefono"
                                label="Telefono o Celular"
                                className="mb-3"
                            >
                                <Form.Control
                                    type="text"
                                    size='sm'
                                    placeholder="Telefono o Celular"
                                    maxLength={10}
                                    minLength={7}
                                    required={true}
                                    autoComplete='off'
                                    value={datosNuevoEmpresa.phone}
                                    onChange={value => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, phone: value.target.value })}
                                />
                            </FloatingLabel>
                        </div>

                        <div className='col-md-8'>
                            <FloatingLabel
                                controlId="mail"
                                label="Correo Electronico"
                                className="mb-3"
                            >
                                <Form.Control
                                    type="text"
                                    size='sm'
                                    placeholder="Correo Electronico"
                                    maxLength={250}
                                    required={true}
                                    autoComplete='off'
                                    value={datosNuevoEmpresa.email}
                                    onChange={value => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, email: value.target.value })}
                                />
                            </FloatingLabel>
                        </div>


                        <div className='col-md-7'>
                            <FloatingLabel
                                controlId="address"
                                label="Direccion"
                                className="mb-3"
                            >
                                <Form.Control
                                    size='sm'
                                    type="text"
                                    placeholder="Direccion"
                                    maxLength={250}
                                    required={true}
                                    value={datosNuevoEmpresa.address}
                                    onChange={value => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, address: value.target.value })}
                                />
                            </FloatingLabel>
                        </div>

                        <div className='col-md-5'>
                            <FloatingLabel
                                controlId="merchantreg"
                                label="Registro Mercantil"
                                className="mb-3"
                            >
                                <Form.Control
                                    type="text"
                                    size='sm'
                                    placeholder="Registro Mercantil"
                                    maxLength={250}
                                    required={true}
                                    value={datosNuevoEmpresa.merchant_registration}
                                    onChange={value => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, merchant_registration: value.target.value })}
                                />
                            </FloatingLabel>
                        </div>

                        <div className='col-md-6'>
                            <FloatingLabel
                                controlId='floatingDeparmentid'
                                label="Departamento"
                                className="mb-3"
                            >
                                <Form.Select
                                    size='sm'
                                    value={departmentid}
                                    onChange={event => {
                                        setDepartmentid(event.target.value);
                                        citiesLoad(event.target.value)
                                    }}
                                >
                                    <option value="">Seleccione</option>
                                    {departamentsCities.map((item, key) =>
                                        <option key={key} value={item.value}>{item.text}</option>)}
                                </Form.Select>
                            </FloatingLabel>
                        </div>

                        <div className='col-md-6'>
                            <FloatingLabel
                                controlId='floatingCity'
                                label="Ciudad"
                                className="mb-3"
                            >
                                <Form.Select
                                    size='sm'
                                    value={datosNuevoEmpresa.municipality_id}
                                    onChange={value => {
                                        setDatosNuevoEmpresa({ ...datosNuevoEmpresa, municipality_id: Number(value.target.value) })
                                    }}
                                >
                                    <option value="">Seleccione</option>
                                    {Cities.map((item, key) =>
                                        <option key={key} value={item.value}>{item.text}</option>)}
                                </Form.Select>
                            </FloatingLabel>
                        </div>


                        <div className='col-md-12'>

                            <Card>
                                <Card.Header
                                    style={{ cursor: 'pointer' }}
                                    onClick={cargarInfoMailHost}
                                    className='bg-dark text-white text-center'
                                >ENVIO DE CORREOS
                                </Card.Header>
                                <Card.Body>

                                    <div className='row'>
                                        <div className='col-md-6'>

                                            <FloatingLabel
                                                controlId="mail_username"
                                                label="Correo"
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    size='sm'
                                                    placeholder="Correo"
                                                    required={true}
                                                    value={datosNuevoEmpresa.mail_username}
                                                    onChange={value => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, mail_username: value.target.value })}
                                                />
                                            </FloatingLabel>

                                        </div>

                                        <div className='col-md-6'>
                                            <FloatingLabel
                                                controlId="mail_password"
                                                label="Contraseña"
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    size='sm'
                                                    placeholder="Contraseña"
                                                    required={true}
                                                    value={datosNuevoEmpresa.mail_password}
                                                    onChange={value => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, mail_password: value.target.value })}
                                                />
                                            </FloatingLabel>
                                        </div>

                                        <div className='col-md-4'>
                                            <FloatingLabel
                                                controlId="mail_host"
                                                label="Servidor Correo"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    size='sm'
                                                    placeholder="Servidor Correo"
                                                    required={true}
                                                    value={datosNuevoEmpresa.mail_host}
                                                    onChange={value => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, mail_host: value.target.value })}
                                                />
                                            </FloatingLabel>
                                        </div>

                                        <div className='col-md-4'>
                                            <FloatingLabel
                                                controlId="mail_port"
                                                label="Servidor Puerto"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    size='sm'
                                                    placeholder="Servidor Puerto"
                                                    required={true}
                                                    value={datosNuevoEmpresa.mail_port}
                                                    onChange={value => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, mail_port: value.target.value })}
                                                />
                                            </FloatingLabel>
                                        </div>

                                        <div className='col-md-4'>
                                            <FloatingLabel
                                                controlId="mail_encryption"
                                                label="Servidor Encriptacion"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    size='sm'
                                                    placeholder="Servidor Encriptacion"
                                                    required={true}
                                                    value={datosNuevoEmpresa.mail_encryption}
                                                    onChange={value => setDatosNuevoEmpresa({ ...datosNuevoEmpresa, mail_encryption: value.target.value })}
                                                />
                                            </FloatingLabel>
                                        </div>

                                    </div>

                                </Card.Body>
                            </Card>

                        </div>

                        <div className='col-md-2'>
                            <Button className='mt-3' type='button' variant='danger' onClick={props.cerrarModal}>
                                Cancelar
                            </Button>
                        </div>

                        <div className='col-md-2'>
                            <Button className='mt-3' type='submit' variant='success'>
                                Guardar
                            </Button>
                        </div>

                    </div>

                </Form>

            </Modal.Body>
        </Modal>
    )

}


export default EmpresaNuevoModal;